import { QrReader } from "react-qr-reader";
import { useState, useEffect, useRef } from "react";
import { useMutation } from "react-query";
import apiService from "services/api";

const baseUrl = process.env.REACT_APP_ATTENDANCE_MASTER_URL;

const challengeUrl = `${baseUrl}/api/challenge`;
const verifyUrl = `${baseUrl}/api/verify`;

const ScanAttendancePage = () => {
  const [scannedPayload, setScannedPayload] = useState({ text: null });
  const isTimedOut = useRef(false);
  const timeoutId = useRef(null);

  const { mutateAsync: sendChallengeRequest } = useMutation({
    mutationFn: async (token) => {
      const response = await fetch(challengeUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          identityToken: apiService.auth.token.get(),
        }),
      });
      return response.statusText;
    },
  });

  const { mutateAsync: sendVerifyRequest } = useMutation({
    mutationFn: async (token) => {
      const response = await fetch(verifyUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
        }),
      });
      return response.statusText;
    },
  });

  useEffect(() => {
    const text = scannedPayload?.text;
    if (!text) return;
    if (text.startsWith("challenge:") && !isTimedOut.current) {
      const token = text.replace("challenge:", "");
      sendChallengeRequest(token);
    }
    if (text.startsWith("verify:")) {
      const token = text.replace("verify:", "");
      isTimedOut.current = true;
      if (timeoutId.current) clearTimeout(timeoutId.current);
      timeoutId.current = setTimeout(() => (isTimedOut.current = false), 5000);
      sendVerifyRequest(token);
    }
  }, [scannedPayload?.text, sendChallengeRequest, sendVerifyRequest]);

  return (
    <div className="content">
      <QrReader
        constraints={{ facingMode: "environment" }}
        onResult={(result) => {
          if (result) setScannedPayload(result);
        }}
        style={{ width: "100%" }}
      />
    </div>
  );
};

export default ScanAttendancePage;
